import React from 'react';

const FinancialSection = ({ formData, onChange, ratio }) => {
  return (
    <section id="confidentiel" className="bg-amber-50 border-2 border-amber-200 rounded-xl shadow-sm p-6 scroll-mt-32 mt-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-lg bg-amber-200 flex items-center justify-center">
          <i className="bi bi-wallet2 text-amber-700 text-lg"></i>
        </div>
        <div className="flex-1">
          <h2 className="text-xl font-bold text-slate-800">3. Profil Financier</h2>
          <p className="text-sm text-slate-600">Données sensibles - Accès restreint</p>
        </div>
        <span className="px-3 py-1.5 bg-amber-200 text-amber-800 rounded-full text-xs font-bold">
          <i className="bi bi-lock-fill mr-1"></i>Confidentiel
        </span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-xs md:text-sm font-semibold text-slate-700 mb-1.5">Apport Disponible (€)</label>
          <input 
            type="number" 
            placeholder="50000"
            className="w-full px-3 md:px-4 py-2 md:py-2.5 border-2 border-amber-200 rounded-lg text-sm md:text-base focus:border-amber-500 outline-none transition bg-white"
            value={formData.informations_confidentielles?.apport_disponible || ''}
            onChange={(e) => onChange('apport_disponible', e.target.value)}
          />
        </div>
        <div>
          <label className="block text-xs md:text-sm font-semibold text-slate-700 mb-1.5">Capacité d&apos;Emprunt (€)</label>
          <input 
            type="number" 
            placeholder="300000"
            className="w-full px-3 md:px-4 py-2 md:py-2.5 border-2 border-amber-200 rounded-lg text-sm md:text-base focus:border-amber-500 outline-none transition bg-white"
            value={formData.informations_confidentielles?.capacite_emprunt || ''}
            onChange={(e) => onChange('capacite_emprunt', e.target.value)}
          />
        </div>
        <div>
          <label className="block text-xs md:text-sm font-semibold text-slate-700 mb-1.5">Revenus Annuels (€)</label>
          <input 
            type="number" 
            placeholder="85000"
            className="w-full px-3 md:px-4 py-2 md:py-2.5 border-2 border-amber-200 rounded-lg text-sm md:text-base focus:border-amber-500 outline-none transition bg-white"
            value={formData.informations_confidentielles?.revenus_annuels || ''}
            onChange={(e) => onChange('revenus_annuels', e.target.value)}
          />
          {ratio && (
            <div className="mt-2 p-3 bg-green-50 border border-green-200 rounded-lg">
              <div className="flex items-center justify-between">
                <span className="text-xs font-semibold text-slate-700">Ratio d&apos;endettement</span>
                <span className="text-lg font-bold text-green-600">{ratio}%</span>
              </div>
              <p className="text-xs text-green-700 mt-1">
                {ratio < 33 ? (<><i className="bi bi-check-circle-fill mr-1"></i>Excellent - Capacité élevée</>) : ratio < 40 ? (<><i className="bi bi-exclamation-triangle-fill mr-1"></i>Bon - Attention au taux</>) : (<><i className="bi bi-x-circle-fill mr-1"></i>Élevé - Risque</>)}
              </p>
            </div>
          )}
        </div>
        <div>
          <label className="block text-xs md:text-sm font-semibold text-slate-700 mb-1.5">Banque</label>
          <input 
            type="text" 
            placeholder="Nom de la banque"
            className="w-full px-3 md:px-4 py-2 md:py-2.5 border-2 border-amber-200 rounded-lg text-sm md:text-base focus:border-amber-500 outline-none transition bg-white"
            value={formData.informations_confidentielles?.banque || ''}
            onChange={(e) => onChange('banque', e.target.value)}
          />
        </div>
      </div>
    </section>
  );
};

export default FinancialSection;
